import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { FooterBar } from "./footerBar";
import { LeftBar } from "./leftBar";
import { NavBar } from "./navBar";
import { useAuth } from '../hooks/useAuth';
import { getSessionData } from '../utils/storageUtils';
import { PERFIL_PAINEL_TV } from '../types/PermissaoInterface';

const ROTA_PAINEL = "/kpi/dashboard/paineldecontrole";

const MainPage = (): JSX.Element => {
  useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const token = getSessionData("xc-helpdesk-token");
  const usuario = getSessionData("DadosUsuario");
  const perfilTv = getSessionData("PerfilUsuario") === PERFIL_PAINEL_TV;
  const foraDoPainel = perfilTv && location.pathname !== ROTA_PAINEL;

  useEffect(() => {
    if (!token || !usuario) {
      localStorage.setItem('redirectPath', location.pathname + location.search);
      navigate("/login", { replace: true });
      return;
    }

    if (foraDoPainel) {
      navigate(ROTA_PAINEL, { replace: true });
    }
  }, [navigate, location, token, usuario, foraDoPainel]);

  if (!token || !usuario || foraDoPainel) {
    return <></>;
  }

  return (
    <>
      <NavBar />
      <LeftBar />
      <div className="content-page">
        <Outlet />
      </div>
      <FooterBar />
    </>
  );
};

export { MainPage };
